import * as common from '../common/Common';
import { UserModel, appService } from '../common/AppService';
import { Message } from './Model';

export class KeyboardMobileViewModel {
    private timer: any = null;
    private lastTimestamp = new Date('1999-01-01');
    private processedIDs: { [id: string]: boolean } = {};
    private content = '';

    public code = '';
    public isLoading = true;
    public uiLocation = 'main';
    public keyPadCode = '';
    public user: UserModel = null;
    public displayContent = '';
    public scrollToEnd: () => void;

    public initialize() {
        this.uiLocation = 'main';
        this.code = common.getCookie('code');

        if (this.code) {
            common.callHttp('POST', 'keyboard/user/' + this.code).then((result: any) => {
                this.user = {
                    username: result.Username,
                    nickname: result.Nickname
                } as UserModel;

                this.uiLocation = 'main';
                //this.doTimer();
                this.isLoading = false;
                common.setLongCookie('code', this.code);

                this.doReceiveMessage();
            }, error => {
                this.code = '';
                this.isLoading = false;
            });
        } else {
            this.isLoading = false;
        }
    }

    public typeKeyPad(text: string) {
        this.keyPadCode += text;
    }

    public showKeyPad() {
        this.uiLocation = 'keypad';
        this.keyPadCode = '';
    }

    public goBack() {
        this.uiLocation = 'main';
    }

    public clearKeyPad() {
        this.keyPadCode = '';
    }

    public submitKeyPad() {
        if (!this.keyPadCode) {
            appService.showQuickMessage('Code is empty.', 2000);
        } else {
            appService.showMessage('Working on it...');
            common.callHttp('POST', 'keyboard/user/' + this.keyPadCode).then((result: any) => {
                this.user = {
                    username: result.Username,
                    nickname: result.Nickname
                } as UserModel;

                this.code = this.keyPadCode;
                this.doReceiveMessage();
                this.uiLocation = 'main';
                common.setLongCookie('code', this.code);

                appService.closeMessage();
            }, error => {
                appService.showQuickMessage('Invalid code.', 2000);
                this.keyPadCode = '';
            });
        }
    }

    public disconnect() {
        this.user = null;
        this.code = null;
        common.removeCookie('code');
    }

    public type(messageID?: string) {
        if (!messageID) {
            messageID = common.generateUID();
        }

        let webKit = window['webkit'] as any;
        if (webKit && webKit.messageHandlers && webKit.messageHandlers.sendContent) {
            webKit.messageHandlers.sendContent.postMessage({ text: this.content });
        }

        this.sendMessage(messageID, 'clear');
    }

    public sendReturn(messageID: string) {
        this.type(messageID);

        setTimeout(() => {
            this.enter();
        }, 500);
    }

    public enter() {
        let webKit = window['webkit'] as any;
        if (webKit && webKit.messageHandlers && webKit.messageHandlers.sendContent) {
            webKit.messageHandlers.sendContent.postMessage({ text: '\n' });
        }
    }

    public switch() {
        let webKit = window['webkit'] as any;
        if (webKit && webKit.messageHandlers && webKit.messageHandlers.switch) {
            webKit.messageHandlers.switch.postMessage({});
        }
    }

    public delete() {
        let webKit = window['webkit'] as any;
        if (webKit && webKit.messageHandlers && webKit.messageHandlers.delete) {
            webKit.messageHandlers.delete.postMessage({});
        }
    }

    private sendMessage(data: string, command: string): Promise<void> {
        return new Promise((resolve, reject) => {
            var retryCount = 5;

            var task = () => {
                common.callHttp('POST', 'keyboard/message/desktop', {
                    Code: this.code,
                    Data: JSON.stringify({
                        data: data,
                        command: command,
                        id: common.generateUID()
                    })
                }).then(() => {
                    resolve();
                }, () => {
                    retryCount--;
                    console.log('Retry Left: ' + retryCount.toString());
                    if (retryCount > 0) {
                        setTimeout(() => {
                            task();
                        }, 1000);
                    } else {
                        reject();
                    }
                });
            };

            task();
        });
    }

    private doReceiveMessage() {
        setTimeout(() => {
            common.callHttp('GET', 'keyboard/message/mobile/' + this.code).then(data => {
                let message = JSON.parse(data.toString()) as Message;
                if (!this.processedIDs[message.id]) {
                    this.processedIDs[message.id] = true;
                    this.content = message.data;
                    this.displayContent = message.data.replace(/\n/g, '<br/>');
                    setTimeout(() => {
                        this.scrollToEnd();
                    });

                    switch (message.command) {
                        case 'sendreturn':
                            this.sendReturn(message.id);
                            break;
                        case 'sendtype':
                            this.type(message.id);
                            break;
                    }
                }

                this.doReceiveMessage();
            });
        }, 1000);
    }
}